<template>
    <actions-layout-content :title="pageTitle" :iconName="pageIcon">
        <template v-if="!isSubmitted && !isExpired" #subtitle>{{ $t('pages.auth.reset_password.subtitle') }}</template>

        <template #content>
            <common-content-wrapper :width="isSubmitted ? 'medium' : 'small'">
                <common-content-spacer height="small">
                    <common-message v-if="isSubmitted" type="success">
                        {{ $t('pages.auth.reset_password.notifications.password_changed') }}
                    </common-message>

                    <common-message v-if="isExpired" type="error">
                        {{ $t('pages.auth.reset_password.notifications.request_expired') }}
                    </common-message>

                    <reset-password-form
                        v-if="!isExpired && !isSubmitted"
                        @form-submitted="formSubmitted($event)"
                        @request-expired="requestExpired()"
                    ></reset-password-form>

                    <common-buttons v-if="isSubmitted || isExpired">
                        <common-button
                            type="primary"
                            :route="{ name: RoutesEnum.INDEX.HOME }"
                            :label="$t('pages.auth.reset_password.buttons.go_to_login')"
                        ></common-button>
                    </common-buttons>
                </common-content-spacer>
            </common-content-wrapper>
        </template>
    </actions-layout-content>
</template>

<script>
    import ActionsLayoutContent from 'components/layouts/layout-content/ActionsLayoutContent'
    import ResetPasswordForm from 'components/forms/auth/ResetPasswordForm'
    import RoutesEnum from 'enums/routes.enum'
    import AuthService from '../../services/AuthService'

    export default {
        components: { ActionsLayoutContent, ResetPasswordForm },

        data: () => ({ RoutesEnum, isSubmitted: false, isExpired: false }),

        computed: {
            pageTitle() {
                if (this.isSubmitted) {
                    return this.$t('pages.auth.reset_password.title_submitted')
                } else if (this.isExpired) {
                    return this.$t('pages.auth.reset_password.title_expired')
                }
                return this.$t('pages.auth.reset_password.title')
            },

            pageIcon() {
                return this.isSubmitted ? 'success' : null
            },
        },

        methods: {
            formSubmitted() {
                this.isSubmitted = true
            },

            requestExpired() {
                this.isExpired = true
            },
        },

        mounted() {
            if (AuthService.isSubdomainActive()) {
                AuthService.reloadSubdomainCompany()
            }
        },
    }
</script>
